import cx from 'classnames'
import * as React from 'react'

import { PrismicRichText, RichTextBlock } from '@emico/prismic'

import { getPrismicComponents } from './htmlSerializer'
import styles from './PrismicCategoryTextOnly.module.scss'
import Heading from './typography/Heading'
import overridable from './utils/overridable'

interface OwnProps {
    className?: string
    heading?: React.ReactNode
    subheading?: string
    content?: unknown
    fluid?: boolean
}

export type Props = OwnProps & React.HTMLAttributes<HTMLDivElement>

export const PrismicCategoryTextOnly = ({
    className,
    subheading,
    content,
    heading,
    fluid = true,
    ...htmlProps
}: Props) => (
    <div
        {...htmlProps}
        className={cx(styles.card, styles.variantDefault, className, {
            [styles.fluid]: fluid,
        })}
    >
        <div className={styles.base}>
            <div className={styles.outer}>
                <div className={styles.inner}>
                    {heading && (
                        <Heading
                            element="h1"
                            variant="h1"
                            className={styles.heading}
                            fuss={['castiron']}
                        >
                            {heading}
                        </Heading>
                    )}
                    {subheading && (
                        <Heading
                            element="h2"
                            variant="h2"
                            className={styles.subheading}
                        >
                            {subheading}
                        </Heading>
                    )}
                    {content && (
                        <PrismicRichText
                            render={content as [RichTextBlock]}
                            components={getPrismicComponents({
                                contentClassName: styles.text,
                            })}
                            analyticsContext="prismic.categoryTextonly.content"
                        />
                    )}
                </div>
            </div>
        </div>
    </div>
)

export default overridable('PrismicCategoryTextOnly')(PrismicCategoryTextOnly)
